import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var outline = defineStyle({
    border: '1px solid',
    borderColor: 'neutrals.600',
    borderRadius: 'md',
    fontSize: '16px',
    p: 3,
    _hover: {
        border: '2px solid',
        borderColor: 'neutrals.600 !important',
    },
    _invalid: {
        border: '2px solid',
        borderColor: 'error.500 !important',
        boxShadow: 'none',
        _focusVisible: {
            border: '2px solid',
            borderColor: 'error.500 !important',
        },
    },
    _focusVisible: {
        border: '2px solid',
        borderColor: 'secondary.900 !important',
        boxShadow: 'shadow-low',
    },
    _disabled: {
        border: '1px solid',
        borderColor: 'neutrals.400',
        _hover: {
            border: '1px solid',
            borderColor: 'neutrals.400 !important',
        }
    },
});
var textareaTheme = defineStyleConfig({
    variants: { outline: outline },
});

export { textareaTheme };
//# sourceMappingURL=textarea.js.map
